import { render } from "./QC3.vue?vue&type=template&id=386d7ae9"
import script from "./QC3.vue?vue&type=script&lang=js"
export * from "./QC3.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "386d7ae9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('386d7ae9', __exports__)) {
    console.log('reload')
    api.reload('386d7ae9', __exports__)
  }
  
  module.hot.accept("./QC3.vue?vue&type=template&id=386d7ae9", () => {
    console.log('re-render')
    api.rerender('386d7ae9', render)
  })

}


export default __exports__